
import React from 'react'
import Alert from 'ui/Alert'
import css from './LoginEnableAlert.module.css'

const LoginEnableAlert = ({ enable }) => (
  <div className={css.main}>
    <Alert type='success' title={`Enable ${enable.integration.name}`}>
      We need you to log in before we can enable this integration.
    </Alert>
  </div>
)

export default LoginEnableAlert



// WEBPACK FOOTER //
// ./components/LoginEnableAlert.js